import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import Headline from '../../../../atoms/headline/headline';

import StyledQuestion from './question.style';
import useInterval from '../../../../../hooks/useInterval';

import { getRandomNumber, getRandomItemFromArray } from '../../../../../helper';

const Question = ({ question, onAnimationEnd = () => {} }) => {
  useInterval(onAnimationEnd, 20000);

  const x = useMemo(() => getRandomNumber(-30, 30), []);
  const gradientColor = useMemo(() => getRandomItemFromArray(['yellow', 'blue', 'green']), []);

  return (
    <div style={{ transform: `translateX(${x}vw)` }}>
      <StyledQuestion $gradientColor={gradientColor}>
        <Headline secondary>{question}</Headline>
        <div className="question__after" />
        <div className="question__before" />
      </StyledQuestion>
    </div>
  );
};

Question.propTypes = {
  question: PropTypes.string.isRequired,
  onAnimationEnd: PropTypes.func
};

export default Question;
